<template>
    <div>
        <ul class="nav nav-tabs bg-light rounded-top border border-1">
            <li class="nav-item">
                <div role="button" v-on:click="tab = 1"
                    :class="{ active: tab == 1, 'text-decoration-underline': tab == 1 }" class="nav-link"
                    aria-current="page" href="#">Trajets</div>
            </li>
            <li class="nav-item">
                <div role="button" v-on:click="tab = 2"
                    :class="{ active: tab == 2, 'text-decoration-underline': tab == 2 }" class="nav-link" href="#">
                    Evènements</div>
            </li>
            <li class="nav-item">
                <div role="button" v-on:click="tab = 3"
                    :class="{ active: tab == 3, 'text-decoration-underline': tab == 3 }" class="nav-link" href="#">
                    Positions</div>
            </li>
        </ul>

        <!-- Drives list -->
        <div v-if="this.tab == 1" class="card shadow bg-white">
            <div class="table-responsive p-3">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Départ</th>
                            <th scope="col"></th>
                            <th scope="col" class="text-end">Arrivée</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr v-for="(drive, index) in drives" :key="index">
                            <td colspan="3">
                                <FullDriveDisplay :baliseDrive="drive" />
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div class="card-footer p-3 text-center">
                <RouterLink :to="'/drives/' + this.$route.params.id">Voir toutes les données</RouterLink>
            </div>
        </div>

        <!-- Positions list -->
        <div v-if="tab == 3" class="card shadow bg-white ">
            <div class="table-responsive p-3">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Adresse</th>
                            <th scope="col">Alim</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(position, index) in positions" :key="index">
                            <td v-if="position && position.date"><span class="small text-muted">
                                    {{ position.date }}</span>
                            </td>
                            <td v-else>Données inconnues</td>
                            <td v-if="position && position.address"><span class="small text-muted">
                                    {{ position.address }}</span>
                            </td>
                            <td v-else>Données inconnues</td>
                            <td v-if="position && position.powerVoltage"><span class="small text-muted">
                                    {{ position.powerVoltage }}V</span>
                            </td>
                            <td v-else>Données inconnues</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer p-3 text-center">
                <RouterLink :to="'/positions/' + this.$route.params.id">Voir toutes les données</RouterLink>
            </div>
        </div>

        <!-- Alarms list -->
        <div v-if="tab == 2" class="card shadow bg-white">
            <div class="table-responsive p-3">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Evènement</th>
                            <th scope="col">Adresse</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(alarm, index) in alarms" :key="index">
                            <td v-if="alarm && alarm.date"><span class="small text-muted">
                                    {{ alarm.date }}</span>
                            </td>
                            <td v-else>Données inconnues</td>
                            <td v-if="alarm && alarm.alertName"><span class="small text-muted">
                                    {{ alarm.alertName }}</span>
                            </td>
                            <td v-else>Données inconnues</td>
                            <td v-if="alarm && alarm.address"><span class="small text-muted">
                                    {{ alarm.address }}</span>
                            </td>
                            <td v-else>Données inconnues</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer p-3 text-center">
                <RouterLink :to="'/alerts/' + this.$route.params.id">Voir toutes les données</RouterLink>
            </div>
        </div>
    </div>

</template>

<script>
import FullDriveDisplay from '@/components/display/FullDriveDisplay.vue'

export default {
    props: ['drives', 'alarms', 'positions'],
    components: {
        FullDriveDisplay,
    },
    data() {
        return {
            tab: 1,
        };
    },
}

</script>